// src/hooks/useScrollReveal.js
import { useEffect } from "react";

export function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    // راقب كل العناصر التي فيها كلاس reveal
    const elements = document.querySelectorAll(".reveal, .reveal-left, .reveal-right");
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}